(ns ycweb.app.blitz.unpicking.unpicking
  (:require
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.blitz.picking.picking :as picking]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.components.wrapper :as w]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.sound :as sound]))

(def steps
  (forms/setup-steps
    [{:key :fromlocation :title "Scan Basket, Bin or Trolley"}
     {:key :item-scan :title "Scan Item to Unpick"}
     {:key :tolocation :title "Scan Shelf"}
     {:key :items :title "Scan Items"}]))

(defn scan-action [app-atom {:keys [items dest]}]
  (cond
    (and items (empty? items))
    (do
      (swap! app-atom update-in [:unpicking] assoc :items items)
      (grid/dispatch-action app-atom :unpicking/start {})
      (toaster/open-toast app-atom :success "Finished" {}))

    items
    (do
      (swap! app-atom update-in [:unpicking] assoc :items items)
      (t/transition-next app-atom :unpicking/item-select))

    :else
    (do
      (swap! app-atom update-in [:unpicking] assoc
        :scanned (inc (get-in @app-atom [:unpicking :scanned]))
        :selected-destination dest)
      (t/transition-next app-atom :unpicking/items))))

(defmethod comms/receive :unpicking/scan [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (sound/play :scan)
  (scan-action app-atom e))

(defmethod grid/action :unpicking/scan [app-atom {:keys [scan]} _]
  (let [{:keys [session-id fromlocation selected-item selected-destination]} (get @app-atom :unpicking)]
    (cond
      (=
        (or (:bin selected-destination) (:shelf selected-destination))
        scan)
      (toaster/open-toast app-atom :error "Scan Item" {})


      (= (:barcode fromlocation) scan)
      (toaster/open-toast app-atom :error "Can't unpick to your own trolley" {})

      (not= scan (:barcode selected-item))
      (do
        (toaster/open-subtle-progress app-atom)
        (comms/send :unpicking/shelf-scan
          {:session-id session-id
           :tolocation-barcode scan
           :itembarcode (:barcode selected-item)}))

      :else
      (do
        (toaster/open-subtle-progress app-atom)
        (comms/send :unpicking/scan
          {:session-id session-id
           :itembarcode (:barcode selected-item)
           :tolocation-barcode (or (:bin selected-destination) (:shelf selected-destination))})))))

(defmethod flow/barcode-dispatch-screen :unpicking/items [_ app-atom scan]
  (grid/dispatch-action app-atom :unpicking/scan {:scan scan}))

(rum/defc items < rum/reactive [app-atom]
  (let [{:keys [fromlocation selected-item scanned selected-destination picking-group]} (cmn/curact app-atom :unpicking)
        {:keys [features brand product qty images barcode packingarea orderqty]} selected-item
        group-colour (:colour packingarea)]
    (w/wrapper app-atom "Unpicking" {:steps steps :step :items}
      [[:div.section
        [:h2.u-text-center.heading
         {:class (u/bem :heading [:standard :flush])}
         "Scan items and put onto shelf:"]
        [:h2.u-text-center
         {:class (u/bem :heading [:large])}
         [:b (or (:bin selected-destination) (:shelf selected-destination))]
         [:span.heading__subtext
          "To start unpicking your trolley"]
         [:span.heading__subtext
          "Trolley: " [:b (:name fromlocation)]]
         [:span.heading__subtext.u-margin-top-8
          [:span {:class (u/bem :pill [:small :blue])}
           "Order of " orderqty " items"]]]]
       [:div.slats
        [:article.card.product-card
         [:figure.product-card__hero
          [:span.product-card__scan-count (str (or scanned 0) " / " (or qty 0))]
          [:img.product-card__image
           {:src (u/cloudinary (:public_id (first images)) {:c "lpad"}) :alt ""}]]
         [:div.product-card__content
          [:h1.product-card__title
           [:span.product-card__brand brand]
           [:span.product-card__name product]]
          (when (u/presence features)
            [:div.product-card__variation-wrapper
             "Variation: " [:span.product-card__variation features]])
          [:div.product-card__barcode
           "Barcode: " [:b.u-barcode.u-block barcode]]
          [:div.product-card__footnote
           [:span.pill
            {:class (keyword (str "pill--" group-colour))}
            (:displayname picking-group) " Item"]]]]]]
      []
      (grid/pos-call-to-action
        {:left-fn
         #(do
            (t/transition-next app-atom :unpicking/start)
            (grid/dispatch-action app-atom :unpicking/start {:scan (:barcode fromlocation)}))
         :right-plain true}))))

(defmethod flow/render-screen :unpicking/items [app-atom _]
  (items app-atom))

(defmethod comms/receive :unpicking/shelf-scan [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (sound/play :scan)
  (scan-action app-atom e))

(defmethod grid/action :unpicking/scan-shelf [app-atom {:keys [scan]} _]
  (let [{:keys [fromlocation session-id selected-item]} (get @app-atom :unpicking)]

    (cond
      (= (:barcode fromlocation) scan)
      (toaster/open-toast app-atom :error "Can't unpick to your own trolley" {})

      :else
      (do
        (toaster/open-subtle-progress app-atom)
        (comms/send :unpicking/shelf-scan
          {:session-id session-id
           :tolocation-barcode scan
           :itembarcode (:barcode selected-item)})))))

(defmethod flow/barcode-dispatch-screen :unpicking/scan-shelf [_ app-atom scan]
  (grid/dispatch-action app-atom :unpicking/scan-shelf {:scan scan}))

(rum/defc scan-shelf < rum/reactive [app-atom]
  (let [{:keys [fromlocation scanned selected-item]} (cmn/curact app-atom :unpicking)
        {:keys [features brand product dest qty images barcode packingarea orderqty]} selected-item

        dest
        (if (:shelf (first dest))
          (str/join ", " (map :shelf dest))
          (str/capitalize packingarea))
        picking-group {:displayname "Small"}
        group-colour (:colour packingarea)]
    (w/wrapper app-atom "Unpicking" {:steps steps :step :tolocation}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard :flush])}
         "Scan Shelf:"]
        [:h2.u-text-center
         {:class (u/bem :heading [:large])}
         [:b dest]
         [:span.heading__subtext
          "To start unpicking your trolley"]
         [:span.heading__subtext
          "Trolley: " [:b (:name fromlocation)]]
         [:span.heading__subtext.u-margin-top-8
          [:span {:class (u/bem :pill [:small :blue])}
           "Order of " orderqty " items"]]]]
       [:div.slats
        [:article.card
         {:class (u/bem :product-card [:is-disabled])}
         [:figure.product-card__hero
          [:span.product-card__scan-count (str (or scanned 0) " / " (or qty 0))]
          [:img.product-card__image
           {:src (u/cloudinary (:public_id (first images)) {:c "lpad"}) :alt ""}]]
         [:div.product-card__content
          [:h1.product-card__title
           [:span.product-card__brand brand]
           [:span.product-card__name product]]
          (when (u/presence features)
            [:div.product-card__variation-wrapper
             "Variation: " [:span.product-card__variation features]])
          [:div.product-card__barcode
           "Barcode: " [:b.u-barcode.u-block barcode]]
          [:div.product-card__footnote
           [:span.pill
            {:class (keyword (str "pill--" group-colour))}
            (:displayname picking-group) " Item"]]]]]]
      []
      (grid/pos-call-to-action
        {:left-fn
         #(do
            (t/transition-next app-atom :unpicking/start)
            (grid/dispatch-action app-atom :unpicking/start {:scan (:barcode fromlocation)}))
         :right-text "Scan Shelf"
         :right-plain true}))))

(defmethod flow/render-screen :unpicking/scan-shelf [app-atom _]
  (scan-shelf app-atom))

(defmethod comms/receive :unpicking/item-select [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (sound/play :scan)
  (let [{:keys [product dest qty] :as item} (:selected-item e)]
    (swap! app-atom update :unpicking assoc
      :selected-item item
      :scanned 0)
    (sound/tts
      (str "Unpick " qty ", " product ". " "to " (:shelf (first dest)))))
  (t/transition-next app-atom :unpicking/scan-shelf))

(defmethod grid/action :unpicking/item-select [app-atom {:keys [scan]} _]
  (let [{:keys [fromlocation items]} (get @app-atom :unpicking)
        fromlocation-id (:id fromlocation)
        selected-item (first (filter #(= scan (:barcode %)) items))]
    (cond
      (nil? selected-item)
      (toaster/open-toast app-atom :error "Item not found" {})

      :else
      (do
        (toaster/open-subtle-progress app-atom)
        (comms/send :unpicking/item-select
          {:scan scan
           :fromlocation-id fromlocation-id})))))

(defmethod flow/barcode-dispatch-screen :unpicking/item-select [_ app-atom scan]
  (grid/dispatch-action app-atom :unpicking/item-select {:scan scan}))

(rum/defc item-slat < rum/reactive [selected-item]
  (let [[slat-color slat-bg-color]
        (picking/slat-colour (:colour (:packingarea selected-item)))]
    [:article.slat.product-slat.product-slat--pulse-plus
     {:class (u/bem :slat [slat-color slat-bg-color])}
     [:div.product-slat__qty
      [:span (:qty selected-item)]]
     [:div.product-slat__info
      [:header.product-slat__header
       [:div.product-slat__title-wrapper
        [:h1.product-slat__title [:span.product-slat__brand (:brand selected-item)] (:product selected-item)]]]
      [:span.product-slat__location
       (or
         (:shelf (:dest selected-item))
         (:name (:packingarea selected-item)))]
      [:div.product-slat__details
       [:span.product-slat__variation (:features selected-item)]
       [:span.product-slat__barcode
        [:b.u-barcode (:barcode selected-item)]]]]]))

(rum/defc item-select < rum/reactive [app-atom]
  (let [{:keys [items fromlocation]} (cmn/curact app-atom :unpicking)]
    (w/wrapper app-atom "Unpicking" {:steps steps :step :item-scan}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Scan Item to start Unpicking"
         [:span {:class "heading__subtext"}
          "Trolley: " [:b (:name fromlocation)]]]]
       [:div.slats
        (map item-slat items)]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Item"
         :right-plain true}))))

(defmethod flow/render-screen :unpicking/item-select [app-atom _]
  (item-select app-atom))

(defmethod comms/receive :unpicking/start [app-atom {:keys [fromlocation session-id unpicking-items]}]
  (toaster/close-subtle-progress app-atom)
  (sound/play :scan)
  (swap! app-atom update :unpicking assoc
    :fromlocation fromlocation
    :items unpicking-items
    :session-id session-id)
  (t/transition-next app-atom :unpicking/item-select))

(defmethod grid/action :unpicking/fromlocation [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :unpicking/start {:barcode scan}))

(defmethod flow/barcode-dispatch-screen :unpicking/fromlocation [_ app-atom scan]
  (grid/dispatch-action app-atom :unpicking/fromlocation {:scan scan}))

(defn bin-colour [bin-name]
  (case (last bin-name)
    \G
    [:green :green-bg]

    \R
    [:red :red-bg]

    \B
    [:blue :blue-bg]

    \Y
    [:yellow :yellow-bg]

    \C
    [:orange :orange-bg]

    \P
    [:purple :purple-bg]

    [:grey :grey-bg]))

(rum/defc unpicking-location-slat < rum/reactive
  [{:keys [item_count location_name] :as location}]
  [:article.slat-wrapper
   [:div.picking-slat
    {:class (u/bem :slat (bin-colour location_name))}
    [:div.picking-slat__graphic-wrapper
     [:div.picking-slat__icon-wrapper
      [:i {:class (u/bem :icon [:2-2 :block :location])}]]]
    [:div.picking-slat__info
     [:h3
      {:class (u/bem :picking-slat__title [:large])}
      location_name]
     [:span.picking-slat__description
      "Item count: "
      [:b item_count]]]]])

(rum/defc fromlocation-screen < rum/reactive [app-atom]
  (let [locations (cmn/curact app-atom [:unpicking :unpicking-locations])]
    (w/wrapper app-atom "Unpicking" {:steps steps :step :fromlocation}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Scan Basket, Bin or Trolley"
         [:span.heading__subtext
          "To start unpicking"]
         grid/barcode-icon]]
       [:div.slats
        (map
          (fn [i]
            (when (> (:item_count i) 0)
              (unpicking-location-slat i)))
          locations)]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-next app-atom :main-menu)
         :right-text "Scan to Unpick"
         :right-plain true}))))

(defmethod flow/render-screen :unpicking/fromlocation [app-atom _]
  (fromlocation-screen app-atom))

(defmethod comms/receive :unpicking/list-unpicking-locations [app-atom {:keys [unpicking-locations]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update :unpicking assoc
    :unpicking-locations unpicking-locations)
  (t/transition-next app-atom :unpicking/fromlocation))

(defmethod grid/action :unpicking/start [app-atom _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :unpicking/list-unpicking-locations
    {:warehouse-id (get-in @app-atom [:login :warehouse_id])}))